import { UserModuleClassProgress } from '../../models/interfaces/user-module-class-progress.interface';

const USER_ID = '1c41afca-e637-4d9f-8cd1-2b3f3302f80d';
const DATE_2026_02_10 = '2026-02-10';
const DATE_2026_02_11 = '2026-02-11';
const DATE_2026_02_12 = '2026-02-12';
const DATE_2026_02_13 = '2026-02-13';
const DATE_2026_03_09 = '2026-03-09';
const DATE_2026_03_10 = '2026-03-10';
const DATE_2026_03_11 = '2026-03-11';

export const userModuleClassProgressMock: UserModuleClassProgress[] = [
  {
    id: 'user-module-class-progress-1',
    userId: USER_ID,
    classId: 'module-1-class-1',
    progress: 100,
    startedAt: new Date(DATE_2026_02_10),
    completedAt: new Date(DATE_2026_02_10),
    lastAccessedAt: new Date(DATE_2026_02_10),
    createdAt: new Date(DATE_2026_02_10),
    updatedAt: new Date(DATE_2026_02_10),
    isActive: true,
  },
  {
    id: 'user-module-class-progress-2',
    userId: USER_ID,
    classId: 'module-1-class-2',
    progress: 100,
    startedAt: new Date(DATE_2026_02_11),
    completedAt: new Date(DATE_2026_02_11),
    lastAccessedAt: new Date(DATE_2026_02_11),
    createdAt: new Date(DATE_2026_02_11),
    updatedAt: new Date(DATE_2026_02_11),
    isActive: true,
  },
  {
    id: 'user-module-class-progress-3',
    userId: USER_ID,
    classId: 'module-1-class-3',
    progress: 100,
    startedAt: new Date(DATE_2026_02_12),
    completedAt: new Date(DATE_2026_02_12),
    lastAccessedAt: new Date(DATE_2026_02_12),
    createdAt: new Date(DATE_2026_02_12),
    updatedAt: new Date(DATE_2026_02_12),
    isActive: true,
  },
  {
    id: 'user-module-class-progress-4',
    userId: USER_ID,
    classId: 'module-1-class-4',
    progress: 100,
    startedAt: new Date(DATE_2026_02_13),
    completedAt: new Date(DATE_2026_02_13),
    lastAccessedAt: new Date(DATE_2026_02_13),
    createdAt: new Date(DATE_2026_02_13),
    updatedAt: new Date(DATE_2026_02_13),
    isActive: true,
  },
  {
    id: 'user-module-class-progress-5',
    userId: USER_ID,
    classId: 'module-2-class-1',
    progress: 100,
    startedAt: new Date(DATE_2026_03_09),
    completedAt: new Date(DATE_2026_03_09),
    lastAccessedAt: new Date(DATE_2026_03_09),
    createdAt: new Date(DATE_2026_03_09),
    updatedAt: new Date(DATE_2026_03_09),
    isActive: true,
  },
  {
    id: 'user-module-class-progress-6',
    userId: USER_ID,
    classId: 'module-2-class-2',
    progress: 100,
    startedAt: new Date(DATE_2026_03_10),
    completedAt: new Date(DATE_2026_03_10),
    lastAccessedAt: new Date(DATE_2026_03_10),
    createdAt: new Date(DATE_2026_03_10),
    updatedAt: new Date(DATE_2026_03_10),
    isActive: true,
  },
  {
    id: 'user-module-class-progress-7',
    userId: USER_ID,
    classId: 'module-2-class-3',
    progress: 100,
    startedAt: new Date(DATE_2026_03_11),
    completedAt: new Date(DATE_2026_03_11),
    lastAccessedAt: new Date(DATE_2026_03_11),
    createdAt: new Date(DATE_2026_03_11),
    updatedAt: new Date(DATE_2026_03_11),
    isActive: true,
  },
];
